import React, { useState } from 'react'
import * as Yup from 'yup';
import dynamic from 'next/dynamic'
import { useFormik } from "formik";
import Captcha from "../../Captcha/Captcha";
import { useCommonEnquiryMutation } from '../../Store/Features/CommonFormAPI';
import Toast from '../../Common/Toast';
import { encode } from '../../../utils/encrypt';
import { useRouter } from 'next/router';


const BorderBtn = dynamic(() => import('../../Common/BorderBtn', { ssr: false }));

export default function BuyNow({ sampleSlug, addingCart, isAdded }) {

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [LoadingStatus, setLoadingStatus] = useState(false);
    const [captchaToken, setCaptchaToken] = useState('');
    const [captchaChacked, setCaptchaChacked] = useState(false);
    const [formAPICallBack] = useCommonEnquiryMutation();
    const { push } = useRouter();
    const fields = [
        {
            name: `name`,
            // label: 'Your Name',
            validation: Yup.string().required('Name is required'),
            customClass: 'md:col-span-6 col-span-12',
            placeholder: 'Full Name*',
        },
        {
            name: 'email',
            type: 'email',
            // label: 'Email',
            validation: Yup.string().email('Invalid email').required('Email is required'),
            customClass: 'md:col-span-6 col-span-12',
            placeholder: 'Add Your Company E-mail Address*',
        }
    ]

    const validationSchema = Yup.object().shape(
        fields.reduce((schema, field) => {
            schema[field.name] = field.validation;
            return schema;
        }, {})
    );


    const formik = useFormik({
        initialValues: fields.reduce((initialValues, field) => {
            initialValues[field.name] = "";
            return initialValues;
        }, {}),
        validationSchema,
        onSubmit: (values, { resetForm }) => {
            setLoadingStatus(true);

            let endpoint = "enquiry/report-store-form";
            if (captchaToken == '') {
                setCaptchaChacked(true);
                setLoadingStatus(false);
            } else {
                
                let payload = {
                    name: values.name,
                    email: values.email,
                    product_name: sampleSlug ? sampleSlug : null,
                    page_name: "Report Profile",
                    form_name: "Buy Now",
                    source_url: window.location.href,
                    source_url_from: document.referrer,
                    validation_token: captchaToken
                };
                formAPICallBack({
                    data: { data: encode(payload) },
                    url: endpoint
                }).then((response) => {
                    if (response) {
                        if (response.data.code == 200) {
                            setTimeout(() => {
                                push('/cart');
                            }, 1000);
                            resetForm();
                        } else {
                            setLoadingStatus(false);
                            Toast("Something went wrong", 'error');
                        }
                    } else {
                        setLoadingStatus(false);
                        Toast("Something went wrong", 'error');
                    }
                }).catch((error) => {
                    setLoadingStatus(false);
                    Toast("Something went wrong", 'error');
                });
            }
        },
    });



    const getting_captcha = (token) => {
        setCaptchaToken(token);
    };

    const [formErrors, setFormErrors] = useState({});

    const validateForm = () => {
        const errors = {};
        if (!formik.values.name?.trim()) {
            errors.name = 'Name is required';
        }
        if (!formik.values.email?.trim()) {
            errors.email = 'Email is required';
        } else if (!/\S+@\S+\.\S+/.test(formik.values.email)) {
            errors.email = 'Email is invalid';
        }
        setFormErrors(errors);
        return Object.keys(errors).length === 0;
    };
    return (
        <div>
            <button onClick={() => setIsModalOpen(true)} className="mt-2 mx-auto flex justify-center bg-[#1e5df3] w-full mx-auto hover:bg-[#1b5df3] text-black font-semibold py-2 px-6 rounded text-sm licPriTypeBtn">
                Click Here to Buy
            </button>

            {isModalOpen && (
                <>
                    <div className="fixed inset-0 z-50 flex items-center justify-center overflow-hidden overflow-x-hidden outline-none focus:outline-none">
                        {/* Modal content */}
                        <div className="modal-content bg-white rounded-lg shadow-lg z-10 lg:w-[40%] w-[90%]">
                            <div class="flex justify-between p-4 modal-header">
                                <h2 class="text-lg ml-auto mr-auto font-semibold text-[#1b5df3]">
                                    Enter Details to Proceed
                                </h2>
                                <button class="text-lg text-red-400 hover:text-red-400" onClick={() => setIsModalOpen(false)}>
                                    <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
                                    </svg>
                                </button>
                            </div>
                            <hr />
                            <div className="w-full h-full p-5 overflow-x-hidden overflow-y-auto modal-body max-h-96">
                                <form className='' onSubmit={formik.handleSubmit} encType="multipart/form-data">
                                    <div className="grid grid-cols-12 gap-4">
                                        {fields?.map((field) => {
                                            return (field.type === "textarea") ?
                                            (
                                                <div
                                                    key={field.name}
                                                    className={field.customClass}>
                                                    <label
                                                        htmlFor={field.name}
                                                        className="block text-sm font-semibold leading-6 text-gray-900 dark:text-white"
                                                    >
                                                        {field.label}
                                                    </label>
                                                    <textarea
                                                        rows={field.col_row ? field.col_row : 2}
                                                        defaultValue={""}
                                                        type={field.type || "text"}
                                                        id={field.name}
                                                        name={field.name}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values[field.name]}
                                                        placeholder={field.placeholder || ""}
                                                        className={(field.className) ? field.className : `w-full py-2 px-4 border  text-gray-900 rounded focus:outline-none shadow-sm focus:border-blue-500 ${formik.touched[field.name] && formik.errors[field.name]
                                                            ? "border-red-500"
                                                            : "focus:border-blue-500"
                                                            }`}
                                                    />
                                                    {formik.touched[field.name] && formik.errors[field.name] && (
                                                        <div className="text-sm text-red-600 error">
                                                            {formik.errors[field.name]}
                                                        </div>
                                                    )}
                                                </div>
                                            )
                                            :
                                            (field.type === 'number') ?
                                            (
                                                <div
                                                    key={field.name}
                                                    className={field.customClass}>
                                                    <label
                                                        htmlFor={field.name}
                                                        className="block text-sm font-semibold leading-6 text-gray-900 dark:text-white">
                                                        {field.label}
                                                    </label>
                                                    <input
                                                        type={field.type || "number"}
                                                        id={field.name}
                                                        name={field.name}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values[field.name]}
                                                        placeholder={field.placeholder || ""}
                                                        className={(field.className) ? field.className : `w-full py-2 px-4 border  text-gray-900 rounded focus:outline-none shadow-sm focus:border-blue-500 ${formik.touched[field.name] && formik.errors[field.name]
                                                            ? "border-red-500"
                                                            : "focus:border-blue-500"
                                                            }`}
                                                    // className="block w-full p-4 text-gray-900 border-0 rounded shadow-sm ring-1 ring-inset dark:text-white ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                                    />
                                                    {formik.touched[field.name] && formik.errors[field.name] && (
                                                        <div className="text-sm text-red-600 error">
                                                            {formik.errors[field.name]}
                                                        </div>
                                                    )}
                                                </div>
                                            )
                                            :
                                            (
                                                <div
                                                    key={field.name}
                                                    className={field.customClass}>
                                                    <label
                                                        htmlFor={field.name}
                                                        className="block text-sm font-semibold leading-6 text-gray-900 dark:text-white">
                                                        {field.label}
                                                    </label>
                                                    <input
                                                        type={field.type || "text"}
                                                        id={field.name}
                                                        name={field.name}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values[field.name]}
                                                        placeholder={field.placeholder || ""}
                                                        className={(field.className) ? field.className : `w-full py-2 px-4 border  text-gray-900 rounded focus:outline-none shadow-sm focus:border-blue-500 ${formik.touched[field.name] && formik.errors[field.name]
                                                            ? "border-red-500"
                                                            : "focus:border-blue-500"
                                                            }`}
                                                        required
                                                    // className="block w-full p-4 text-gray-900 border-0 rounded shadow-sm ring-1 ring-inset dark:text-white ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                                    />
                                                    {formik.touched[field.name] && formik.errors[field.name] && (
                                                        <div className="text-sm text-red-600 error">
                                                            {formik.errors[field.name]}
                                                        </div>
                                                    )}
                                                </div>
                                            );
                                        })}
                                        <div className="hidden col-span-12 md:col-span-12">
                                            <Captcha onChange={getting_captcha} />
                                            {captchaChacked && (
                                                <div className="text-sm text-center text-red-600 error">
                                                    Please Complete Captcha
                                                </div>
                                            )}
                                        </div>
                                        {isAdded ?
                                            <>
                                                <div className='col-span-12 mx-auto'>
                                                    <BorderBtn
                                                        // onClick={() => {
                                                        //     if(captchaToken!=""){
                                                        //         addingCart()
                                                        //     }
                                                        // }}
                                                        customClass="fit hightLightBtn text-white font-semibold py-2 px-6 rounded text-sm "
                                                        buttonTitle="Go To Cart"
                                                        buttonLink="/cart"
                                                    />
                                                </div>
                                            </>
                                            :
                                            <div className='col-span-12 md:col-span-12'>
                                                <button
                                                    type="submit"
                                                    onClick={() => {
                                                        if (validateForm()) {
                                                            if (captchaToken !== "") {
                                                                addingCart()
                                                            } else {
                                                                setFormErrors(prev => ({
                                                                    ...prev,
                                                                    captcha: 'Please complete the captcha verification'
                                                                }));
                                                            }
                                                        }
                                                    }}
                                                    disabled={false} // You can change this condition as needed
                                                    className="block px-8 py-2 mx-auto text-sm font-semibold text-center text-white rounded shadow-sm w-fit delve-bg-primary hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                                                >
                                                    Buy Now
                                                </button>
                                            </div>
                                        }
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div className="fixed inset-0 z-30 bg-black opacity-50"></div>
                </>
            )}
        </div>
    )
}